class Services {
    constructor(
        public collect: boolean,
        public treatment: boolean
    ) {}
}




export class Query {
    constructor(
        public location: string,
        public radius: number,
        public services: Services,
        public wastes: string[]
    ) {}
}



// WEBPACK FOOTER //
// /Users/julien/code/urbyn/urbyn-backoffice/src/app/haulers/query.model.ts